import { render, staticRenderFns } from "./custom-domain-dialog.vue?vue&type=template&id=4bffc888&scoped=true&"
import script from "./custom-domain-dialog.vue?vue&type=script&lang=js&"
export * from "./custom-domain-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffc888",
  null
  
)

export default component.exports